const LocalStorageConstant: any = {
  accessToken: "access_token",
  refreshToken: "refresh_token",
  user: "user",
  refreshTokenTimer:"refresh_token_timer",
  firstTimeLogin: "firstTimeLogin",
  selectedCustomer: "customer-selected",
};

export default LocalStorageConstant;
